import './ScaledText.less'

const ScaledText = ({ children, size = 10, className = '', style = {} }: any) => {
  const baseSize = 12 // Chrome 对中文的最小渲染字号
  const scale = size / baseSize

  return (
    <span
      className={`scaled-text ${className}`}
      style={{
        fontSize: `${baseSize}px`,
        transform: `scale(${scale})`,
        transformOrigin: 'left top',
        display: 'inline-block',
        ...style
      }}
    >
      {children}
    </span>
  )
}

export default ScaledText
